import { z } from "zod";
import { RequestParameterTypeEnumSchema } from "../Enums/RequestParameterTypeEnum";
import { SectionOrFieldDtoSchema } from "./SectionOrFieldDto";

export const SectionOrFieldGroupDtoSchema = z.object({
    group: z.string().nullish(),
    groupFieldType: RequestParameterTypeEnumSchema.nullish(),
    children: z.array(SectionOrFieldDtoSchema),
    groupValue: z.string().nullish(), // Added by FE
});

export type SectionOrFieldGroupDto = z.infer<typeof SectionOrFieldGroupDtoSchema>;